<template>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$tx('hygl.components.meetingAgenda', '会议议题', '会议议题')" name="second">
            <el-table border :data="tableData" style="margin-bottom: 20px" @row-click="rowClick">
                <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                <el-table-column :label="$tx('hygl.components.topics', '议题')" align="left" prop="flSubject" />
                <el-table-column :label="$tx('hygl.components.reporter', '汇报人')" align="left" width="80" prop="flCreator" />
                <el-table-column :label="$tx('hygl.components.reportTime', '汇报时长(分钟)')" align="center" width="110" prop="reportTime" />
                <el-table-column :label="$tx('hygl.components.durationTime', '讨论时长(分钟)')" align="center" width="110" prop="talkTime" />
                <el-table-column :label="$tx('hygl.components.attendees', '列席人员')" align="left" width="200" prop="attendStoolName" />
                <el-table-column :label="$tx('hygl.components.attachNum', '附件数量')" width="65" align="center">
                    <template #default="scope">
                        <span style="cursor: pointer" @click="downloadFucYt(scope.row.id, scope.row.passenger.ytNum)">{{ scope.row.passenger.ytNum }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$tx('hygl.components.meetinger', '会议人员')" name="third" class="hyryBox">
            <el-table v-model="tableDataPeople" border :data="tableDataPeople">
                <el-table-column :label="$tx('fields.index', '序号')" align="center" type="index" />
                <el-table-column :label="$tx('fields.name', '姓名')" align="left" prop="userName" />
                <el-table-column :label="$tx('hygl.components.duties', '职务')" width="100" align="left" prop="userPost" />
                <el-table-column :label="$tx('hygl.components.depart', '部门')" width="100" align="left" prop="userDept" />
                <el-table-column :label="$tx('hygl.components.phone', '联系电话')" width="100" align="center" prop="phone" />
                <el-table-column :label="$tx('hygl.components.personType', '人员类型')" width="100" align="center" prop="meetPersonType">
                    <template #default="scope">
                        <span v-if="scope.row.meetPersonType === 1" v-text-lbl="'insider'">内部人员</span>
                        <span v-if="scope.row.meetPersonType === 2" v-text-lbl="'outsiders'">外部人员</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$tx('fields.remark', '备注')" align="left" width="100" prop="remark" />
            </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$tx('hygl.components.meetingMinutes', '会议记录')" name="fourth">
            <div class="textW" style="width: 100%; overflow: hidden; overflow-y: hidden">
                <el-input v-model="vo.meetRecord" disabled type="textarea" :rows="2" placeholder=""></el-input>
            </div>
        </el-tab-pane>
        <el-tab-pane v-if="getzhuanpai !== null" :label="$tx('hygl.components.transferRecord', '转派记录')" name="zhuanpai">
            <el-form :model="getzhuanpai">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" class="el-table__body">
                            <tbody>
                                <tr>
                                    <td v-text-lbl="'transferPersonnel'" class="el-table__cell tdlbl tdw17" colspan="1">转派人</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <span>{{ getzhuanpai.turnsendName }}</span>
                                    </td>
                                    <td v-text-lbl="'transferTime'" class="el-table__cell tdlbl tdw17" colspan="1">转派时间</td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <span>{{ getzhuanpai.turnsendTime }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_会议主题" v-text-lbl="'transferReason'" class="el-table__cell tdlbl tdw17" colspan="1">转派原因</td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <span>{{ getzhuanpai.tsReason }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            getzhuanpai: {},
            tableData: [],
            tableDataPeople: [],
            activeName: 'second'
        }
    },
    computed: {},
    watch: {},
    created() {
        this.initGetById(this.vo.id)
        this.getPeople()
        this.getzhuanpais()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        handleClick(tab, event) {
            if (tab.name === 'third') {
                this.getPeople()
            }
            if (tab.name === 'zhuanpai') {
                this.getzhuanpais()
            }
        },
        async initGetById(resultobj) {
            const res = await this.$app.getById('/hygl/hyap/getById', resultobj)
            if (res.code === 'success') {
                this.vo = res.body.vo
                this.getzhuanpais()
                if (this.vo.ytObject) {
                    this.tableData = JSON.parse(this.vo.ytObject)
                }
            } else {
                this.$message.error(res.message)
            }
        },
        async getPeople() {
            const search = [
                {
                    compare: '=',
                    field: 'meetId',
                    merge: true,
                    value: this.vo.id
                }
            ]
            const res = await this.$app.querydata('/hygl/meetPeople/querydata', search, 'orgFullOrderNo asc')
            if (res.code === 'success') {
                this.tableDataPeople = res.body.listdata
            } else {
                this.$message.error(res.message)
            }
        },
        // 获取转派记录
        async getzhuanpais() {
            const search = [
                {
                    compare: '=',
                    field: 'meetId',
                    merge: true,
                    value: this.vo.id
                }
            ]
            const res = await this.$app.querydata('/hygl/meetPeople/querydata', search, 'orgFullOrderNo asc')
            if (res.code === 'success') {
                for (let i = 0; i < res.body.listdata.length; i++) {
                    if (res.body.listdata[i].regStatus === 3 || res.body.listdata[i].regStatus === '3') {
                        this.getzhuanpai = res.body.listdata[i]
                    }
                }
            } else {
                this.$message.error(res.message)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.hyryBox {
    /deep/ .el-table::before {
        content: none;
    }
}
</style>
